// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608132025/js/" + chunkId + "." + {"44":"d97e16fd","225":"6d120c4d","481":"993cb815","486":"c7f75e81","770":"9f3b28e3"}[chunkId] + ".0.21365215904648738.chunk.js";
};